import React from 'react';
import { Switch, Route } from 'react-router-dom';
import LoginPage from '../Auth/pages/LoginPage/LoginPage';
import HubspotIntegrationInstructionPage from '../Auth/pages/HubspotIntegrationInstructionPage/HubspotIntegrationInstructionPage';
import EmailAlertUnsubscribePage from '../Setup/pages/EmailAlertsPage/EmailAlertUnsubscribePage';

const Routes = () => (
  <Switch>
    <Route path="/signin" exact component={LoginPage} />
    <Route path="/signin/form" exact component={LoginPage} />
    <Route path="/signin/hubspot/instructions" exact component={HubspotIntegrationInstructionPage} />
    <Route path="/unsubscribe/email-alert" exact component={EmailAlertUnsubscribePage} />
    <Route path="/reset" exact component={LoginPage} />
  </Switch>
);
export default Routes;
